import { apiClient } from "./ApiClient";

const USER_API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v1/users`;

export default {
  list({ page, page_size, sort, order, section_id = -1, search_term, platoon_id = -1 }) {
    return apiClient.get(
      `${USER_API_URL}?page=${page}&page_size=${page_size}&sort=${sort}&order=${order}&section_id=${section_id}&search_term=${search_term}&platoon_id=${platoon_id}`
    );
  },
  add({
    name,
    user_id,
    date_of_birth,
    password,
    gender,
    height_cm,
    weight_kg,
    platoon_id,
    section_id,
    role_id,
    devices,
  }) {
    return apiClient.post(`${USER_API_URL}/`, {
      name,
      user_id,
      date_of_birth,
      password,
      gender,
      height_cm,
      weight_kg,
      platoon_id,
      section_id,
      role_id,
      devices,
    });
  },
  edit({
    udid,
    name,
    date_of_birth,
    gender,
    height_cm,
    weight_kg,
    platoon_id,
    section_id,
    role_id,
    devices,
  }) {
    return apiClient.put(`${USER_API_URL}/`, {
      udid,
      name,
      date_of_birth,
      gender,
      height_cm,
      weight_kg,
      platoon_id,
      section_id,
      role_id,
      devices,
    });
  },
  resetPassword({ udid, new_password }) {
    return apiClient.put(`${USER_API_URL}/reset_password`, {
      udid,
      new_password,
    });
  },
  deactivate(udid) {
    return apiClient.put(`${USER_API_URL}/deactivate`, {
      udid,
    });
  },
  activate(udid) {
    return apiClient.put(`${USER_API_URL}/activate`, {
      udid,
    });
  },
  revokeToken(udid) {
    return apiClient.put(`${USER_API_URL}/revoke_token`, {
      udid,
    });
  },
  topRankingUsers({ period, label, offset, chunkSize, day, platoon_id, search_term, page_num }) {
    return apiClient.get(
      `${USER_API_URL}/challenge/ranks?period=${period}&label=${label}&offset=${offset}&chunkSize=${chunkSize}&day=${day}&platoon_id=${platoon_id}&search_term=${search_term}&page_num=${page_num}`
    );
  }
};
